import { PreparationBreadcrumb } from '@modules/OrderPreparation/shared';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Preparation } from '../../models';

interface BreadcrumbProps {
    preparation: Preparation;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ preparation }) => {
    const { t } = useTranslation('pickingModule');

    return (
        <PreparationBreadcrumb
            preparationCode={preparation.code}
            preparationStatus={preparation.status}
            breadcrumbLabel={t('breadcrumb.picking')}
        />
    );
}; 